import { TWidget } from 'widgets/Widget';
import { TProduct as TBaseProduct, TAvailabilityModel } from 'types/models/product';

export type TProduct = TBaseProduct & {
    price: TBaseProduct['price'] & { html: string };
    stock: null | number;
    availability: TAvailabilityModel;
    tabbyInfoPdpHtml: string;
};

/**
 * @description Base ProductDetail implementation
 * @param ProductDetail Base widget for extending
 * @returns Product Detail widget
 */
function TabbyProductDetailClassCreator(ProductDetail: import('widgets/product/ProductDetail').TProductDetail) {
    class TabbyProductDetail extends ProductDetail {
        /**
         * @description Update Product View
         * @param product productModel
         */
        updateProductView(product: TProduct): void {
            super.updateProductView(product);
            this.renderTabbyMsg(product);
        }

        /**
         * @description Render Tabby onsite message
         * @param product Product object
         */
        renderTabbyMsg(product: TProduct): void {
            if (product.tabbyInfoPdpHtml) {
                this.getById('tabbyMsgBlock', tabbyMsgBlock => {
                    tabbyMsgBlock.render('template', {}, undefined, product.tabbyInfoPdpHtml);
                });
            }
        }

        /**
         * @description Show error message
         * @param widget - Widget that emit error
         * @param errorMessage - Error message string
         */
        showError(widget: TWidget, errorMessage: string): void {
            this.showCartMessage(errorMessage, true);
        }
    }

    return TabbyProductDetail;
}

export type TTabbyProductDetail = ReturnType<typeof TabbyProductDetailClassCreator>;

export type TTabbyProductDetailInstance = InstanceType<TTabbyProductDetail>;

export default TabbyProductDetailClassCreator;
